export const LogoHorizontal = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      zoomAndPan="magnify"
      viewBox="0 0 799.34537 140.87891"
      preserveAspectRatio="xMidYMid"
      version="1.0"
      id="svg78"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs id="defs4" />
      <g fill="currentColor" fillOpacity="1" id="g12" transform="translate(-48.368003,-142.86634)">
        <g transform="translate(46.879718,281.32728)" id="g10">
          <g id="g8">
            <path
              d="m 64.304688,-69.511719 v -24.34375 H 42.003906 V -125.26563 L 15.613281,-106.125 v 12.269531 h -14.125 v 24.34375 h 14.125 v 30.667969 c 0,24.347656 20.070313,40.886719 48.136719,40.886719 v -26.203125 c -12.082031,0 -21.746094,-4.832032 -21.746094,-15.425782 v -29.925781 z m 0,0"
              id="path6"
            />
          </g>
        </g>
      </g>
      <g fill="currentColor" fillOpacity="1" id="g20" transform="translate(-48.368003,-142.86634)">
        <g transform="translate(113.97166,281.32728)" id="g18">
          <g id="g16">
            <path
              d="m 76.574219,-33.640625 c -4.277344,6.691406 -12.269531,9.480469 -20.261719,9.480469 -2.785156,0 -5.386719,-0.1875 -7.804688,-1.117188 l 52.410158,-37.542968 c -5.76172,-17.46875 -23.601564,-33.082032 -46.832032,-33.082032 -26.949219,0 -48.695313,21.933594 -48.695313,49.066406 0,26.761719 22.671875,48.878907 50.921875,48.878907 16.730469,0 33.269531,-7.617188 41.261719,-19.511719 z M 32.152344,-46.835938 c 0,-13.195312 9.851562,-22.675781 21.933594,-22.675781 5.015624,0 9.289062,1.675781 13.007812,4.460938 l -34.199219,24.347656 c -0.554687,-1.859375 -0.742187,-3.902344 -0.742187,-6.132813 z m 0,0"
              id="path14"
            />
          </g>
        </g>
      </g>
      <g fill="currentColor" fillOpacity="1" id="g28" transform="translate(-48.368003,-142.86634)">
        <g transform="translate(220.27803,281.32728)" id="g26">
          <g id="g24">
            <path
              d="M 43.117188,-33.082031 76.757812,0 H 110.39844 L 61.148438,-49.996094 108.35547,-93.855469 H 75.644531 L 35.683594,-56.5 v -81.96094 H 9.292969 V 0 h 26.390625 v -26.019531 z m 0,0"
              id="path22"
            />
          </g>
        </g>
      </g>
      <g fill="currentColor" fillOpacity="1" id="g36" transform="translate(-48.368003,-142.86634)">
        <g transform="translate(329.55798,281.32728)" id="g34">
          <g id="g32">
            <path
              d="m 33.453125,-37.730469 c 5.949219,0.929688 8.363281,3.53125 8.363281,7.25 0,3.53125 -2.230468,6.320313 -7.0625,6.320313 -4.085937,0 -7.433594,-1.117188 -10.222656,-4.089844 L 2.230469,-12.082031 c 8.175781,9.292969 18.398437,14.125 32.339843,14.125 20.257813,0 36.054688,-13.007813 36.054688,-32.152344 0,-19.328125 -13.195312,-28.25 -30.480469,-30.480469 -7.804687,-0.929687 -10.035156,-2.785156 -10.035156,-5.945312 0,-2.789063 2.042969,-4.832032 5.574219,-4.832032 3.53125,0 6.132812,1.671876 8.550781,3.902344 L 63.191406,-81.21875 C 56.5,-90.882812 47.207031,-95.902344 35.125,-95.902344 c -13.9375,0 -30.851562,12.082032 -30.851562,28.4375 0,15.984375 12.082031,27.320313 29.179687,29.734375 z m 0,0"
              id="path30"
            />
          </g>
        </g>
      </g>
      <g fill="currentColor" fillOpacity="1" id="g44" transform="translate(-48.368003,-142.86634)">
        <g transform="translate(404.26981,281.32728)" id="g42">
          <g id="g40">
            <path
              d="m 64.304688,-69.511719 v -24.34375 H 42.003906 V -125.26563 L 15.613281,-106.125 v 12.269531 h -14.125 v 24.34375 h 14.125 v 30.667969 c 0,24.347656 20.070313,40.886719 48.136719,40.886719 v -26.203125 c -12.082031,0 -21.746094,-4.832032 -21.746094,-15.425782 v -29.925781 z m 0,0"
              id="path38"
            />
          </g>
        </g>
      </g>
      <g fill="currentColor" fillOpacity="1" id="g52" transform="translate(-48.368003,-142.86634)">
        <g transform="translate(471.36176,281.32728)" id="g50">
          <g id="g48">
            <path
              d="m 74.34375,-93.855469 v 6.503907 c -4.089844,-4.460938 -14.5,-8.550782 -22.863281,-8.550782 -25.089844,0 -46.089844,21.933594 -46.089844,49.066406 0,26.761719 20.441406,48.878907 46.089844,48.878907 8.550781,0 18.773437,-3.34375 22.863281,-8.734375 V 0 h 26.39063 v -93.855469 z m -20.257812,69.695313 c -12.082032,0 -21.933594,-9.292969 -21.933594,-22.675782 0,-13.195312 9.851562,-22.675781 21.933594,-22.675781 12.265624,0 21.371093,9.480469 21.371093,22.675781 0,13.382813 -9.105469,22.675782 -21.371093,22.675782 z m 0,0"
              id="path46"
            />
          </g>
        </g>
      </g>
      <g fill="currentColor" fillOpacity="1" id="g60" transform="translate(-48.368003,-142.86634)">
        <g transform="translate(581.38514,281.32728)" id="g58">
          <g id="g56">
            <path
              d="m 25.460938,-26.019531 c -8.546876,0 -14.308594,6.320312 -14.308594,14.3125 0,7.617187 5.761718,14.125 14.308594,14.125 8.738281,0 14.3125,-6.507813 14.3125,-14.125 0,-7.992188 -5.761719,-14.3125 -14.3125,-14.3125 z m 0,0"
              id="path54"
            />
          </g>
        </g>
      </g>
      <g fill="currentColor" fillOpacity="1" id="g68" transform="translate(-48.368003,-142.86634)">
        <g transform="translate(632.30813,281.32728)" id="g66">
          <g id="g64">
            <path
              d="m 103.89453,-46.835938 c 0,-27.132812 -17.843749,-49.066406 -43.492186,-49.066406 -8.546875,0 -19.515625,2.601563 -24.71875,8.550782 v -6.503907 H 9.292969 V 0 h 26.390625 v -46.835938 c 0,-15.054687 10.78125,-22.675781 22.488281,-22.675781 10.78125,0 19.515625,7.621094 19.515625,22.675781 V 0 h 26.20703 z m 0,0"
              id="path62"
            />
          </g>
        </g>
      </g>
      <g fill="currentColor" fillOpacity="1" id="g76" transform="translate(-48.368003,-142.86634)">
        <g transform="translate(744.18999,281.32728)" id="g74">
          <g id="g72">
            <path
              d="m 54.085938,-95.902344 c -26.949219,0 -48.695313,21.933594 -48.695313,49.066406 0,26.761719 21.746094,48.878907 48.695313,48.878907 26.945312,0 49.437502,-22.117188 49.437502,-48.878907 0,-27.132812 -22.49219,-49.066406 -49.437502,-49.066406 z m 0,71.742188 c -12.082032,0 -21.933594,-9.292969 -21.933594,-22.675782 0,-13.195312 9.851562,-22.675781 21.933594,-22.675781 12.820312,0 22.488281,9.480469 22.488281,22.675781 0,13.382813 -9.667969,22.675782 -22.488281,22.675782 z m 0,0"
              id="path70"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
